import React, { createContext, useState, useContext } from "react";

import { ContextType } from "../utility/Types";

export const context = createContext<ContextType | null>(null);

export const ContextProvider = ({ children }: any) => {

    const [isAnimating, setIsAnimating] = useState(false);
    const [user, setUser] = useState<any>(null);
    const [globalVariable, setGlobalVariable] = useState<Record<string, any>>({});

    return (
        <context.Provider
            value={{
                user, setUser,
                isAnimating, setIsAnimating,
                globalVariable, setGlobalVariable
            }}
        >
            {children}
        </context.Provider>
    );
};

export const useAppContext = () => {
    const ctx = useContext(context);

    if (!ctx) {
        throw new Error("useAppContext must be used within ContextProvider");
    }

    return ctx;
};